import { UpdateAttributesApiModel } from '@era/inroom-sdk';
import { Action } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { Attributes } from './attributes.state';

export enum AttributesActionTypes {
  // SignalR
  ATTRIBUTES_SIGNALR_STATE_CHANGED = '[Attributes SignalR] Attributes State Changed',

  // Resolver
  ATTRIBUTES_RESOLVER_ATTRIBUTES_REQUESTED = '[Attributes resolver] Attributes requested',

  // Views
  ATTRIBUTES_VIEW_SAVE_ATTRIBUTES = '[Attributes view] Save Attributes',

  // API
  ATTRIBUTES_API_ATTRIBUTES_LOADED = '[Attributes API] Attributes loaded',
  ATTRIBUTES_API_ATTRIBUTES_LOADED_ERROR = '[Attributes API] Attributes loaded error',
  ATTRIBUTES_API_ATTRIBUTES_DELETED = '[Attributes API] Attributes deleted',
  ATTRIBUTES_API_ATTRIBUTES_DELETED_ERROR = '[Attributes API] Attributes deleted error',
  ATTRIBUTES_API_ATTRIBUTES_UPDATED = '[Attributes API] Attributes updated',
  ATTRIBUTES_API_ATTRIBUTES_UPDATED_ERROR = '[Attributes API] Attributes updated error',
}

export class AttributesSignalRStateChange implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_SIGNALR_STATE_CHANGED;

  constructor(public payload: { changes: UpdateAttributesApiModel }) {}
}

export class AttributesResolverAttributesRequested implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_RESOLVER_ATTRIBUTES_REQUESTED;

  constructor(public payload: { reservationId: string }) {}
}

// Views
export class AttributesViewSaveAttributes implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_VIEW_SAVE_ATTRIBUTES;

  constructor(public payload: { attributes: Attributes }) {}
}

// API
export class AttributesApiAttributesLoaded implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_LOADED;

  constructor(public payload: { attributes: Attributes }) {}
}

export class AttributesApiAttributesLoadedError implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_LOADED_ERROR;

  constructor(public payload: { error: ErrorModel }) {}
}

export class AttributesApiAttributesDeleted implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_DELETED;

  constructor(public payload: { attributes: Attributes }) {}
}

export class AttributesApiAttributesDeletedError implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_DELETED_ERROR;

  constructor(public payload: { attributes: Attributes; error: ErrorModel }) {}
}

export class AttributesApiAttributesUpdated implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_UPDATED;

  constructor(public payload: { attributes: Attributes }) {}
}

export class AttributesApiAttributesUpdatedError implements Action {
  readonly type = AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_UPDATED_ERROR;

  constructor(public payload: { originalAttributes: Attributes; attributes: Attributes; error: ErrorModel }) {}
}

export type AttributesActionUnion =
  // SignalR
  | AttributesSignalRStateChange
  // Resolver
  | AttributesResolverAttributesRequested
  // Views
  | AttributesViewSaveAttributes
  // API
  | AttributesApiAttributesLoaded
  | AttributesApiAttributesLoadedError
  | AttributesApiAttributesUpdated
  | AttributesApiAttributesUpdatedError
  | AttributesApiAttributesDeleted
  | AttributesApiAttributesDeletedError;
